import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';

import { CompanyConsentModel } from '../../model';

@Injectable({
  providedIn: 'root',
})
export class ConsentService {
  constructor(private http: HttpClient) {}

  public getCompanyConsents(): Observable<CompanyConsentModel[]> {
    return this.http.get<CompanyConsentModel[]>(`${environment.apiEndpoint}/account/consent`);
  }

  public updateConsent(
    type:
      | 'VINLIVT_TERMS_OF_USE_CLIENT'
      | 'VINLIVT_PRIVACY_CLIENT'
      | 'PARTNER_PRIVACY_CLIENT'
      | 'PARTNER_INITIAL_INFORMATION',
    body: string,
  ): Observable<void> {
    return this.http.post<void>(`${environment.apiEndpoint}/account/consent/${type}`, body, {
      headers: { 'Content-Type': 'text/plain' },
    });
  }
}
